var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "sand",
    patternUnits: "userSpaceOnUse",
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#f4a460"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 2,
    fill: "#d2b48c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 3,
    fill: "#d2b48c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 2,
    fill: "#d2b48c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 80,
    r: 1,
    fill: "#d2b48c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 70,
    r: 2,
    fill: "#d2b48c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#sand)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSand);
export default __webpack_public_path__ + "static/media/sand.25ede08f5aa8e8f4ee4ece5a1e07d477.svg";
export { ForwardRef as ReactComponent };